import styled from "styled-components";
import Img from "gatsby-image";

export const WhyContainer = styled.div`
  position: relative;
  min-height: 7rem;
  padding: 1rem;
  background-color: inherit;
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  justify-content: center;
  align-items: center;
  color: #1c0824;
  grid-gap: 2rem;
  @media screen and (max-width: 786px) {
    grid-template-columns: 1fr;
  }
`;
export const WhyImportantBlock = styled.div`
  position: relative;
  display: block;
  text-align: left;
  padding: 2rem;
  padding-bottom: 2rem;
`;
export const GalleryBlock = styled.div`
  position: relative;
  display: flex;
  text-align: left;
  padding: 1rem;
  padding-bottom: 2rem;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
export const WhyServiceTitle = styled.p`
  display: block;
  font-size: 24px;
  font-weight: 300px;
`;
export const WhyServiceDescription = styled.div`
  display: flex;
  font-size: 18px;
  font-weight: 250px;
  margin-top: 20px;
`;
export const AnswerTitleBlock = styled.p`
  display: block;
`;
export const AnswerBlock = styled.p`
  margin-left: 20px;
  display: block;
  font-size: 16px;
  font-weight: 100px;
  color: #7d605f;
`;
export const MoreButton = styled.button`
  color: #fff;
  /* background: #4c006e; */
  padding: 10px;
  padding-right: 25px;
  padding-left: 25px;
  border-radius: 5px;
  font-size: 18px;
  font-weight: 250px;
  color: #62407a;
  -webkit-transition: background 0.2s ease-in-out;
  transition: background 0.2s ease-in-out;
  -ms-transition: background 0.2s ease-in-out;
  -webkit-transition: color 0.2s;
  transition: color 0.2s ease-in-out;
  -ms-transition: color 0.2s ease-in-out;
  -webkit-transition: border 0.2s;
  transition: border 0.2s ease-in-out;
  -ms-transition: border 0.2s ease-in-out;

  /* border: 1px solid #7d605f; */
  &:hover {
    background: #f6f4ff;
    -webkit-transition: background 0.2s ease-in-out;
    transition: background 0.2s ease-in-out;
    -ms-transition: background 0.2s ease-in-out;
    -webkit-transition: color 0.2s;
    transition: color 0.2s ease-in-out;
    -ms-transition: color 0.2s ease-in-out;
    -webkit-transition: border 0.2s;
    transition: border 0.2s ease-in-out;
    -ms-transition: border 0.2s ease-in-out;
  }
`;
export const MoreButtonContainer = styled.div`
  color: #7d605f;
  display: flex;

  justify-content: flex-end;
  padding: 10px;
`;
export const GalleryImage = styled(Img)`
  border-radius: 10px;
  height: 100%;
  filter: brightness(60%);
  max-height: 350px;
  /* max-width: 450px; */
  justify-content: flex-end;
  transition: 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    filter: brightness(65%);
  }
`;
// export
